import { render, staticRenderFns } from "./admin-user-balance.vue?vue&type=template&id=7f0778cf&"
import script from "./admin-user-balance.vue?vue&type=script&lang=js&"
export * from "./admin-user-balance.vue?vue&type=script&lang=js&"
import style0 from "./admin-user-balance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports